import {Component, OnInit} from "@angular/core";
import {Observable} from "rxjs";
import {switchMap, tap} from "rxjs/operators";
import {Feature, ReleaseFeaturesService} from "./release-features.service";

@Component({
    selector: "app-release-features",
    templateUrl: "./release-features.component.html",
    standalone: false
})
export class ReleaseFeaturesComponent implements OnInit {

  features: Feature[] = [];

  constructor(private readonly releaseFeaturesService: ReleaseFeaturesService) {
  }

  ngOnInit() {
    this.loadFeatures().subscribe();
  }

  releaseFeature(name: string) {
    this.releaseFeaturesService
      .releaseFeature(name)
      .pipe(switchMap(() => this.loadFeatures()))
      .subscribe();
  }

  private loadFeatures(): Observable<Feature[]> {
    return this.releaseFeaturesService
      .getFeatures()
      .pipe(tap(features => this.features = features));
  }
}
